import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class SelectApiRoomService extends BaseService {
  fetchApiRooms = (data) => this.axios.post(API_ENDPOINTS.SELECT_API_ROOMS, data);
}
